var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEwinFootballInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/40x40px/eWin-index/Fb/info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/40x40px/eWin-index/Fb/info"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0000333,36.6877013 C8.95468159,36.6877013 6.75015599e-14,35.5263047 6.75015599e-14,34.0938507 C6.75015599e-14,32.6613966 8.95468159,31.5 20.0000333,31.5 C31.0460517,31.5 40.0000667,32.6613966 40.0000667,34.0938507 C40.0000667,35.5263047 31.0460517,36.6877013 20.0000333,36.6877013 Z",
    id: "Fill-7",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "orange-book-svgrepo-com",
    transform: "translate(20.000000, 19.465517) scale(1, -1) translate(-20.000000, -19.465517) translate(6.000000, 4.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,21.6168582 C28,23.4535753 26.5251733,24.9425287 24.7058824,24.9425287 L3.29411765,24.9425287 C1.47482671,24.9425287 0,23.4535753 0,21.6168582 L0,5.24873946 C0,3.41213793 4.76905882,0 6.58823529,0 L23.5735294,0 C26.1215294,0 28,1.92223755 28,4.46886973 L28,21.6168582 Z",
    id: "Path",
    fill: "#569171",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5478655,24.8889264 C26.5478655,26.7552472 24.9249945,28.2681992 23.0764277,28.2681992 L5.00996153,28.2681992 C3.16139473,28.2681992 1.66275956,26.7552472 1.66275956,24.8889264 L1.68456465,4.82095813 C1.68456465,1.34115191 1.66699224,1.44168528 5.8684725,1.44168528 L23.0981571,1.44168528 C24.9467239,1.44168528 26.5695949,2.95463727 26.5695949,4.82095813 L26.5478655,24.8889264 Z",
    id: "Path",
    fill: "#EBF5F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4334483,26.4853376 C25.4334483,28.3883434 23.9263148,29.9310345 22.0671714,29.9310345 L3.69627689,29.9310345 C1.8371335,29.9310345 0.33,28.3883434 0.33,26.4853376 L0.33,6.34224865 C0.33,4.43924279 1.8371335,2.89655172 3.69627689,2.89655172 L22.0671714,2.89655172 C23.9263148,2.89655172 25.4334483,4.43924279 25.4334483,6.34224865 L25.4334483,26.4853376 Z",
    id: "Path",
    fill: "#569171",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2830053,26.8070745 C24.2830053,28.2681992 23.3822873,29.9310345 21.5231439,29.9310345 L3.69627689,29.9310345 C1.8371335,29.9310345 0.33,28.3883434 0.33,26.4853376 L0.33,7.48235002 C0.33,5.57934416 1.8371335,4.18564211 3.69627689,4.18564211 L21.1986541,4.18015247 C23.0576805,4.18015247 24.2830053,5.28545637 24.2830053,7.1883425 L24.2830053,26.8070745 Z",
    id: "Path",
    fill: "#00C06C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(14.548621, 16.911034) scale(1, -1) translate(-14.548621, -16.911034) translate(13.250000, 10.891034)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.29862069,12.04 C0.581412287,12.04 0,11.4585877 0,10.7413793 L0,5.54689655 C0,4.82968815 0.581412287,4.24827586 1.29862069,4.24827586 C2.01582909,4.24827586 2.59724138,4.82968815 2.59724138,5.54689655 L2.59724138,10.7413793 C2.59724138,11.4585877 2.01582909,12.04 1.29862069,12.04 Z",
    id: "info-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29862069,0 C2.01582909,0 2.59724138,0.581412287 2.59724138,1.29862069 C2.59724138,2.01582909 2.01582909,2.59724138 1.29862069,2.59724138 C0.581412287,2.59724138 0,2.01582909 0,1.29862069 C0,0.581412287 0.581412287,0 1.29862069,0 Z",
    id: "info-path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.19769452,2.89655172 C3.2368548,2.89655172 2.89436154,2.33750328 3.60074451,1.84821717 C4.31278444,1.35501268 5.0978782,1.23371648 7.02094716,1.23371648 L8.31962149,1.23371648 L8.31417625,0 L6.05355172,0 C2.75365517,0 0,2.07854406 0,4.46886973 L0,26.605364 C0,28.4420811 1.4889534,29.9310345 3.3256705,29.9310345 L4.98850575,29.9310345 L5.02911214,2.89655172 L4.19769452,2.89655172 Z",
    id: "Path",
    fill: "#569171",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEwinFootballInfo);
export default __webpack_public_path__ + "static/media/ewin_football_info.4120c7cf9d50fb367bf5d15bbf75ff51.svg";
export { ForwardRef as ReactComponent };